var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E81313"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1515 27.1723C33.9532 27.4258 33.6786 27.6088 33.3683 27.6942C33.058 27.7796 32.7285 27.763 32.4284 27.6467L27.8346 26.0164L27.8074 26.0061C27.5777 25.9142 27.3743 25.7669 27.2153 25.5773C27.0563 25.3877 26.9467 25.1617 26.8962 24.9195L26.314 22.1305C24.8036 21.6158 23.1647 21.6194 21.6565 22.1408L21.1034 24.9083C21.0546 25.1532 20.9454 25.382 20.7858 25.5741C20.6262 25.7661 20.4212 25.9152 20.1893 26.008L20.1621 26.0183L15.5684 27.6467C15.3979 27.7139 15.2164 27.7489 15.0331 27.7498C14.8049 27.7503 14.5797 27.6986 14.3745 27.5989C14.1693 27.4991 13.9896 27.3539 13.849 27.1742C12.2337 25.0911 12.4146 22.3264 14.2887 20.4514C19.5528 15.1855 28.4449 15.1855 33.7118 20.4514C35.5859 22.3245 35.7668 25.0892 34.1515 27.1723ZM32.2503 29.9998H15.7503C15.5513 29.9998 15.3606 30.0789 15.2199 30.2195C15.0793 30.3602 15.0003 30.5509 15.0003 30.7498C15.0003 30.9488 15.0793 31.1395 15.2199 31.2802C15.3606 31.4208 15.5513 31.4998 15.7503 31.4998H32.2503C32.4492 31.4998 32.6399 31.4208 32.7806 31.2802C32.9212 31.1395 33.0003 30.9488 33.0003 30.7498C33.0003 30.5509 32.9212 30.3602 32.7806 30.2195C32.6399 30.0789 32.4492 29.9998 32.2503 29.9998Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/EndCall.b92541f83d1dcd19841b1a20f15d3985.svg";
export { ForwardRef as ReactComponent };